import { Box, useTheme } from '@mui/material';
import { HTMLAttributes, useContext } from 'react';

import { LocaleContext } from '@/Contexts/LocaleContext';

export interface CharacterLimitHelperTextProps extends HTMLAttributes<HTMLSpanElement> {
  limit: number;
}

function CharacterLimitHelperText({ limit }: CharacterLimitHelperTextProps) {
  const { translatedText } = useContext(LocaleContext);
  return (
    <Box
      style={{
        position: 'relative',
        top: '5px',
        width: '100%',
      }}
    >
      <Box
        style={{
          width: '250px',
          position: 'absolute',
          right: '5px',
          textAlign: 'right',
        }}
      >
        {translatedText.myaccount.characterlimit(limit)}
      </Box>
    </Box>
  );
}

export default CharacterLimitHelperText;
